import * as React from "react";
import styles from "./SignUpForm.module.scss";
import parse from "html-react-parser";
import { signUpTermsParser } from "@utils/signUpTermsParser";
import { trackMxpEvent } from "@utils/mixpanelEvents/mixpanelEvents";

type TermsAndServicesType = {
  termsAgreementText?: Queries.builder_SignUpTermsData["termsAgreementText"];
};

const TermsAndServices: React.FC<TermsAndServicesType> = ({
  termsAgreementText,
}) => {
  const handleLink = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const mixPanelData = {
      sp_destination: e.currentTarget.href,
      sp_link_text: e.currentTarget.textContent,
    };

    trackMxpEvent("user: link clicked", mixPanelData);
  };

  const textContent = termsAgreementText ? (
    <div className={styles.signUpCheckboxLabel}>
      {parse(termsAgreementText!, {
        replace: signUpTermsParser,
      })}
    </div>
  ) : (
    <div className={styles.signUpCheckboxLabel}>
      On behalf of myself and the practice, I agree to the{" "}
      <a
        onClick={handleLink}
        target="_blank"
        href="https://www.simplepractice.com/baa"
        rel="noreferrer"
      >
        Business Associate Agreement
      </a>
      , the{" "}
      <a
        onClick={handleLink}
        target="_blank"
        href="https://www.simplepractice.com/terms"
        rel="noreferrer"
      >
        Terms of Service
      </a>
      , and the{" "}
      <a
        onClick={handleLink}
        target="_blank"
        href="https://www.simplepractice.com/privacy"
        rel="noreferrer"
      >
        Privacy Policy
      </a>{" "}
      for my account.
    </div>
  );

  return textContent;
};

export default TermsAndServices;
